import { Expandable } from "@components/atoms/Expandable"
import { Themed, ThemeName } from "@components/atoms/Themed"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useBlockContext } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Accordion Item",
}

export default defineBlock("content/accordion-item", (props) => {
  const info = useBlockContext()
  const index = info?.index || 0
  const themes = ["olive", "brick", "navy"]
  const theme = themes[index % themes.length]

  return (
    <Themed theme={theme as ThemeName} className={cn("w-full")}>
      <Expandable
        buttonClassName="themed-bg themed-fg rounded-lg p-7 !flex-col !items-start gap-5"
        label={
          <EditableText
            store="title"
            as="p"
            className="type-title-m md:type-title-l w-full"
            placeholder="Enter title"
          />
        }
        icon={
          <svg className="w-8 h-8 md:w-7 md:h-7" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="35" height="34" rx="17" stroke="currentColor" />
            <path
              d="M21.542 17.988V19.192H18.98V21.754H17.776V19.192H15.228V17.988H17.776V15.426H18.98V17.988H21.542Z"
              fill="currentColor"
            />
          </svg>
        }
        iconOpen={
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            className="w-8 h-8 md:w-7 md:h-7"
            viewBox="0, 0, 37, 36"
          >
            <rect x="1" y="1" width="35" height="34" rx="17" stroke="currentColor" />
            <path d="M14.742,18.084 L21.047,18.084" fillOpacity="0" stroke="currentColor" strokeWidth="1.1" />
          </svg>
        }
        contentClassName="[&_p]:!w-full [&_p]:!mt-0 [&_.wysiwyg-text]:!w-full [&_.wysiwyg-text]:!mt-0 flex flex-col gap-5 !pb-7"
      >
        <InnerBlocks
          allowedBlocks={["#inline"]}
          template={[["core/paragraph", { placeholder: "Enter accordion content" }]]}
          adminClassName="w-full"
          orientation="horizontal"
        />
      </Expandable>
    </Themed>
  )
})
